import { useEffect } from 'react';

import noop from 'lodash/noop';
import throttle from 'lodash/throttle';

function onScroll(threshold: number, onEndReached: () => void, cache: { top: number }, e: Event) {
  const top = (e.target as HTMLDivElement).scrollTop;
  const viewportHeight = (e.target as HTMLDivElement).clientHeight;
  const thresholdHeight = threshold * viewportHeight;
  const isDown = cache.top < top;

  cache.top = top;

  if (!isDown) {
    return;
  }

  const height = (e.target as HTMLDivElement).scrollHeight - viewportHeight;

  if (top >= height - thresholdHeight) {
    onEndReached?.();
  }
}

function useOnEndReached(element: HTMLElement | null, onEndReached: () => void, threshold = 1) {
  useEffect(() => {
    if (!element) {
      return noop;
    }

    const cache = { top: Infinity };
    const onScrollThrottled = throttle(onScroll.bind({}, threshold, onEndReached, cache), 500);

    element.addEventListener('scroll', onScrollThrottled);

    return () => {
      element.removeEventListener('scroll', onScrollThrottled);
    };
  }, [onEndReached, threshold, element]);
}

export { useOnEndReached, onScroll as _onScroll };
